import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=773e472c&scoped=true&"
import script from "./beneficiary.vue?vue&type=script&lang=js&"
export * from "./beneficiary.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary.vue?vue&type=style&index=0&id=773e472c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e472c",
  null
  
)

export default component.exports